/**************
 Global
 ***************/

// get index of a specific element
function getElIndex(el) {
    let i;
    for (i = 0; el = el.previousElementSibling; i++) ;
    return i;
}

// Intelligems Test Group
const addIntelligemsTestGroup = (formData) => {

    let testGroup;
    const experimentId = 'c2e02be9-f5f9-4c67-be4b-9c23bfcff36c';


    if (window?.igData && window.igData.user) {
        testGroup = window.igData.user.getTestGroup(experimentId);
        if (testGroup && testGroup.id) {
            if (!('properties' in formData)) {
                formData['properties'] = {}
            }

            formData['properties']["_igTestGroup"] = testGroup.id;
        }
    }
    return formData;
}

const addIntelligemsDiscount = (formData) => {
    if (window?.igData && window.igData.user) {
        const variantId = String(formData.id).split(':')[0]
        const hasSellingPlan = !!formData?.selling_plan;
        const discount = window.igData.price.getDiscountByVariantId(variantId, hasSellingPlan);
        if (!discount) {
            return formData;
        }
        if (!('properties' in formData)) {
            formData['properties'] = {}
        }
        formData['properties']["_igLineItemDiscount"] = discount;
    }
    return formData;
}

//add new product to cart
//let formData = { quantity: 1, id: 794864229, properties: { 'Personalize': 'ZHM' } };
function addProduct(formData) {
    formData = addIntelligemsTestGroup(formData);
    formData = addIntelligemsDiscount(formData);

    return fetch('/cart/add.js', {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(function (data) {
            return data.json();
        })
}

//change an existing product in your cart
//let formData = { quantity: 1, id: 794864229 };
function changeProduct(formData) {
    formData = addIntelligemsTestGroup(formData);
    formData = addIntelligemsDiscount(formData);

    return fetch('/cart/change.js', {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(function (data) {
            return data.json();
        })
}

//update cart note or attributes (_ for attributes are hidden and __ are private)
//let formData = { note: 'This is a note about my order', attributes: { 'Gift wrap': 'Yes' } }
function updateCart(formData) {
    formData = addIntelligemsTestGroup(formData);
    formData = addIntelligemsDiscount(formData);

    return fetch('/cart/update.js', {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(function (data) {
            return data.json();
        })
}

//download product
function downloadProduct(handle) {
    return fetch(`/products/${handle}.js`)
        .then(function (data) {
            return data.json();
        })
        .then(function (data) {
            return data;
        })
        .catch((error) => {
            return false;
        });
}


// Converts a price in cents to a formatted string in dollars with a comma as thousands separator
function price(amount) {
    let total = (parseFloat(amount) / 100).toFixed(2);
    total = total.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return `$${total.replace(".00", "")}`;
}